import { gql } from "@apollo/client";

export const GET_MARKETPLACES = gql`
query GetMarketplaces {
  marketplaces {
    id
    name
    vl_fee_percentage
    active
    qa_nets
  }
}
`;

export const UPDATE_MARKETPLACE_FEE = gql`
mutation UpdateMarketplaceFee($id: uuid!, $fee: numeric!, $qaNets: String!) {
  update_marketplaces_by_pk(
    pk_columns: {id: $id}
    _set: {vl_fee_percentage: $fee, qa_nets: $qaNets}
  ) {
    id
    vl_fee_percentage
    qa_nets
  }
}
`;


// export const DELETE_MARKETPLACE = gql`
// mutation DeleteMarketplace($id: uuid!) {
//   delete_marketplaces_by_pk(id: $id) {
//     id
//     name
//   }
// }
// `;

export const TOGGLE_MARKETPLACE = gql`
mutation ToggleMarketplace($id: uuid!, $active: Boolean!) {
  update_marketplaces_by_pk(
    pk_columns: {id: $id}
    _set: {active: $active}
  ) {
    id
    active
  }
}
`;

export const ADD_MARKETPLACE = gql`
mutation AddMarketplace($name: String!, $fee: numeric!, $qaNets: String!) {
  insert_marketplaces_one(
    object:{
      name:$name
      vl_fee_percentage:$fee
      active:true
      qa_nets:$qaNets
    }
  ){
    id
    name
    vl_fee_percentage
    active
    qa_nets
  }
}
`;

export const GET_EMAIL_CAMPAIGN_USERS = gql`
query GetEmailCampaignUsers($searchText: String!, $limit: Int!, $offset: Int!) {
  user_aggregate(
    where: {
      u_deleted_at: { _is_null: true }
      u_role: { _eq: "user" }
      u_is_active: { _eq: true }
      u_email_enabled: { _eq: true }
    }
  ) {
    aggregate {
      count
    }
  }
  push_user_aggregate: user_aggregate(
    where: {
      u_deleted_at: { _is_null: true }
      u_role: { _eq: "user" }
      u_is_active: { _eq: true }
      u_notification_enabled: { _eq: true }
      u_device_tokens: { _is_null: false }
    }
  ) {
    aggregate {
      count
    }
  }
  user(
    where: {
      _or: [{ u_email_id: { _ilike: $searchText } }, { u_full_name: { _ilike: $searchText } }]
      u_deleted_at: { _is_null: true }
      u_role: { _eq: "user" }
      u_is_active: { _eq: true }
    }
    order_by: { u_email_id: asc }
    limit: $limit
    offset: $offset
  ) {
    u_id
    u_full_name
    u_email_id
    u_email_enabled
    u_affiliate_id
    u_sales_reps_id
    u_notification_enabled
    u_device_tokens
    affiliate {
      a_id
      a_email_id
    }
  }
}
`;

export const GET_PUSH_NOTIFICATION_USERS = gql`
query GetPushNotificationUsers($searchText: String!, $limit: Int!, $offset: Int!) {
  push_user_aggregate: user_aggregate(
    where: {
      u_deleted_at: { _is_null: true }
      u_role: { _eq: "user" }
      u_is_active: { _eq: true }
      u_notification_enabled: { _eq: true }
      u_device_tokens: { _is_null: false }
    }
  ) {
    aggregate {
      count
    }
  }
  user(
    where: {
      _or: [
        { u_email_id: { _ilike: $searchText } }
        { u_first_name: { _ilike: $searchText } }
        { u_last_name: { _ilike: $searchText } }
      ]
      u_deleted_at: { _is_null: true }
      u_role: { _eq: "user" }
      u_is_active: { _eq: true }
      u_notification_enabled: { _eq: true }
      u_device_tokens: { _is_null: false }
    }
    order_by: { u_email_id: asc }
    limit: $limit
    offset: $offset
  ) {
    u_id
    u_first_name
    u_last_name
    u_email_id
    u_email_enabled
    u_affiliate_id
    u_sales_reps_id
    u_notification_enabled
    u_device_tokens
    affiliate {
      a_id
      a_email_id
    }
  }
}
`;